import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";

const styles = theme => ({
  card: {
    flex:1,
    maxWidth: "100%",
    maxHeight: "100%",
    background: "url(../../images/loader.svg) center center no-repeat"
  },
  media: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    border: "0px"
  },
  moduleNotAvailbale:{
    color:theme.HeaderSelectedText,
  }
});

function renderIFrame(props){
  if(props.url){
    return (
      <Card className={props.classes.card} elevation={0} key={props.url}>
        <CardMedia component="iframe" className={props.classes.media} src={props.url} />
      </Card>
    );
  }
  else{
    return <div className={props.classes.moduleNotAvailbale}>URL Not Found</div>
  }
}

const IFrameRenderer = props => {
  return renderIFrame(props);
};

export default withStyles(styles)(IFrameRenderer);
